var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 12",
    fill: "#6B758B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.181 2.16568C12.7261 2.36762 12.2373 2.50362 11.7242 2.56492C12.2481 2.2512 12.6504 1.75408 12.8395 1.16165C12.3496 1.4522 11.8066 1.66341 11.2286 1.77726C10.7665 1.28426 10.1066 0.976196 9.37714 0.976196C7.73947 0.976196 6.53608 2.50414 6.90596 4.09029C4.79847 3.98468 2.9295 2.97498 1.6782 1.44035C1.01366 2.58038 1.33356 4.07174 2.46278 4.82695C2.04756 4.81356 1.65605 4.69971 1.3145 4.50962C1.28669 5.68468 2.12896 6.78401 3.34884 7.02871C2.99184 7.12556 2.60084 7.14823 2.20314 7.07198C2.52563 8.07962 3.46217 8.81268 4.57284 8.83329C3.50647 9.66938 2.16296 10.0429 0.817383 9.8842C1.9399 10.6039 3.27363 11.0237 4.70575 11.0237C9.41526 11.0237 12.076 7.04623 11.9153 3.4788C12.4109 3.12077 12.841 2.67414 13.181 2.16568Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterChat);
export default __webpack_public_path__ + "static/media/twitter-chat.1cad2b0528d685310fe157e42cf92a41.svg";
export { ForwardRef as ReactComponent };